import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HomeIcon, MessagesIcon } from '@/ui/primitives/Icon';
import { useChatActions, useChatConfig, useChatState } from '@/ui/ChatProvider';
/** The tab bar under Home and Messages (`config.home`). */
export function SpaceTabs() {
    const { copy } = useChatConfig();
    const { showView } = useChatActions();
    const view = useChatState((s) => s.view);
    const tabs = [
        { id: 'home', label: copy.home, Icon: HomeIcon },
        { id: 'messages', label: copy.messages, Icon: MessagesIcon },
    ];
    return (_jsx("nav", { className: "ac-tabs", children: tabs.map(({ id, label, Icon }) => (_jsxs("button", { type: "button", className: "ac-tab", "aria-current": view === id ? 'page' : undefined, onClick: () => showView(id), children: [_jsx(Icon, {}), _jsx("span", { children: label })] }, id))) }));
}
